// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryButton_container__3k8-t","label":"PrimaryButton_label__1kDZl"};